<template>
  <v-container v-if="RBAC_configuration_VIEW_CONFIGURATION" class="editConfigurationApp">
    <base-material-card :renderCard="card" color="secondary" icon="mdi-tune-vertical"
      :title="$t('configuration_parameter')">
      <div style="display: flex">
        <v-tabs class="editConfigurationTabs" vertical v-model="currentTypeId">
          <v-tab v-for="type in configType" v-bind:key="type.code">
            {{ type.dex }}
          </v-tab>
        </v-tabs>
        <v-container v-if="
          currentType && currentType.subType && currentType.subType.length > 0
        ">
          <v-row>
            <v-toolbar flat color="primary" dark>
              <v-btn v-if="RBAC_configuration_EDIT_CONFIGURATION" class="mx-5" :disabled="haveDesignerModify"
                @click="saveConfiguration" color="success">{{ $t("save") }}</v-btn>
              <v-toolbar-title>{{ currentType.dex }}</v-toolbar-title>
            </v-toolbar>
          </v-row>
          <v-row>
            <v-col :md="subType.contentType === 'html' ||
                subType.contentType === 'email'
                ? 12
                : 4
              " cols="12" v-for="(subType, index) in currentType.subType" v-bind:key="subType.code" class="d-flex"
              style="flex-direction:column">

              <v-card outlined class="mb-1 flex-grow-1">
                <v-card-title class="cardTitle">
                  <manage-config-flag class="cardTitleFlag"
                    :canEdit="RBAC_configuration_EDIT_CONFIGURATION && subType.canEdit"
                    :changeManageFlag="subType.changeManageFlag" v-model="currentType.subType[index].manageFlag" />
                  <div class="cardTitleDiv">{{ subType.dex.toUpperCase() }}</div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="cardTextContainer">

                  <div v-if="subType.contentType === 'email'">
                    <v-row>
                      <v-col cols="6">
                        <tiptap-vuetify :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                          :extensions="extensions" v-model="subType.value"></tiptap-vuetify>
                      </v-col>
                      <v-col cols="6">
                        <v-simple-table v-if="subType.validValues">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Codice speciale</th>
                                <th class="text-left">Valore corrispondente</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in subType.validValues" :key="item.code">
                                <td>{{ item.code }}</td>
                                <td>{{ item.dex }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="
                    subType.contentType === 'html' && subType.validValues && subType.validValues !== ''
                  ">

                    <html-designer v-model="subType.value" :editableFormat="true" :border="false"
                      :inputHTML="subType.value" :selectableField="subType.validValues.elements"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      :canvasX="subType.validValues.canvasX" :canvasY="subType.validValues.canvasY"
                      @change2save="changeByDesigner($event, subType.code)" />
                  </div>
                  <div v-if="
                    subType.contentType === 'html' &&
                    (!subType.validValues || subType.validValues === '')
                  ">

                    <my-html-editor :border="false" :id="subType.code" v-model="subType.value"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" />
                  </div>
                  <div v-if="
                    subType.contentType === 'image' ||
                    subType.contentType === 'svg'
                  ">

                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <img v-if="
                            subType.contentType === 'image' &&
                            subType.preview !== ''
                          " :id="subType.code + '_img'" style="max-width: 100%; height: auto" :src="subType.preview" />
                          <img v-if="subType.contentType === 'svg'" :id="subType.code + '_img'"
                            style="max-width: 100%; height: auto" :src="subType.value" />
                          <v-file-input :id="subType.code"
                            v-if="RBAC_configuration_EDIT_CONFIGURATION && subType.canEdit"
                            v-model="files[subType.code]" @change="onFileChange(subType.code)" color="primary"
                            :placeholder="$t('upload_image')" prepend-icon="mdi-upload" outlined :accept="subType.contentType === 'svg'
                                ? 'image/svg'
                                : 'image/*'
                              " />
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                  <div v-else-if="
                    subType.contentType === 'string' &&
                    subType.validValues &&
                    subType.validValues.length > 0
                  ">

                    <v-select :id="subType.code" v-model="subType.value" :items="getArrayValue(subType.validValues)"
                      item-text="dex" :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      item-value="code" color="primary"></v-select>
                  </div>

                  <div v-else-if="
                    subType.contentType === 'array' && !subType.validValues
                  ">

                    <v-combobox v-model="subType.value"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      :menu-props="{ maxHeight: '400' }" multiple chips color="primary"></v-combobox>
                  </div>
                  <div v-else-if="
                    subType.contentType === 'array' &&
                    subType.validValues &&
                    subType.validValues.length > 0
                  ">

                    <v-select :items="getArrayValue(subType.validValues)" v-model="subType.value"
                      :menu-props="{ maxHeight: '400' }" item-text="dex"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" item-value="code" multiple
                      chips color="primary"></v-select>
                  </div>

                  <div v-else-if="
                    subType.contentType === 'arrayKeyVal' &&
                    subType.validValues
                  ">

                    <my-select-chips-custom-text :items="getArrayValue(subType.validValues)" v-model="subType.value"
                      :menu-props="{ maxHeight: '400' }" item-text="dex"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" item-value="code"
                      color="primary"></my-select-chips-custom-text>
                  </div>

                  <div v-else-if="subType.contentType === 'color'">

                    <v-color-picker :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" v-model="subType.value"
                      mode="hexa" class="ma-2" dot-size="30"></v-color-picker>
                  </div>

                  <div v-else-if="subType.contentType === 'month'">

                    <v-select v-model="subType.value" :id="subType.code" :items="listMonth"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" item-text="dex"
                      item-value="code" color="primary"></v-select>
                  </div>
                  <div v-else-if="subType.contentType === 'locale'">

                    <v-select v-model="subType.value" :id="subType.code" :items="listLocale"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" item-text="dex"
                      item-value="code" color="primary"></v-select>
                  </div>
                  <div v-else-if="
                    (subType.contentType === 'string' && !subType.validValues) ||
                    subType.contentType === 'number' ||
                    subType.contentType === 'link'
                  ">

                    <v-text-field :type="subType.contentType" :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" v-model="subType.value"
                      hide-details="auto"></v-text-field>
                  </div>
                  <div v-if="subType.contentType === 'json'">

                    <v-textarea name="input-7-1" rows="20" :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      v-model="subType.value"></v-textarea>
                  </div>
                  <div v-else-if="subType.contentType === 'date'">

                    <my-datepicker v-model="subType.value" :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit" required="true" />
                  </div>
                  <div v-else-if="subType.contentType === 'boolean'">

                    <v-checkbox false-value="0" true-value="1" :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      v-model="subType.value"></v-checkbox>
                  </div>
                  <div v-else-if="subType.contentType === 'pwd'">

                    <my-password-field :id="subType.code"
                      :disabled="!RBAC_configuration_EDIT_CONFIGURATION || !subType.canEdit"
                      v-model="subType.value"></my-password-field>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import manageConfigFlag from "@/components/base/ManageConfigFlag.vue";
import MyPasswordField from "@/components/base/MyPasswordField.vue";
import MyHtmlEditor from "@/components/base/MyHtmlEditor.vue";
import htmlDesigner from "@/components/base/htmlDesigner.vue";
import MySelectChipsCustomText from "@/components/base/MySelectChipsCustomText.vue";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  name: "edit-configuration",
  components: {
    MyDatepicker,
    MyPasswordField,
    MyHtmlEditor,
    MySelectChipsCustomText,
    TiptapVuetify,
    "manage-config-flag": manageConfigFlag,
    "html-designer": htmlDesigner,
  },
  props: {
    card: false,
  },
  data() {
    return {
      RBAC_configuration_VIEW_CONFIGURATION: false,
      RBAC_configuration_EDIT_CONFIGURATION: false,
      panel: [],
      files: [],
      configType: [],
      configuration: {},
      changedDesigner: {},
      haveDesignerModify: false,
      currentTypeId: null,
      currentType: null,
      listMonth: [
        { code: "1", dex: this.$t("january") },
        { code: "2", dex: this.$t("february") },
        { code: "3", dex: this.$t("march") },
        { code: "4", dex: this.$t("april") },
        { code: "5", dex: this.$t("may") },
        { code: "6", dex: this.$t("june") },
        { code: "7", dex: this.$t("july") },
        { code: "8", dex: this.$t("august") },
        { code: "9", dex: this.$t("september") },
        { code: "10", dex: this.$t("october") },
        { code: "11", dex: this.$t("november") },
        { code: "12", dex: this.$t("december") },
      ],
      listLocale: [
        { code: "it", dex: this.$t("italian") },
        { code: "en", dex: this.$t("english") },
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {},
  mounted() {
    this.loadData();
  },
  watch: {
    currentTypeId: function (newVal, oldVal) {
      this.loadCurrentType();
    },
  },
  methods: {
    changeByDesigner(value, key) {
      let _ = this;
      _.changedDesigner[key] = value;
      _.haveDesignerModify = false;
      for (let key of Object.keys(_.changedDesigner)) {
        if (_.changedDesigner[key] === true) {
          _.haveDesignerModify = true;
          break;
        }
      }
    },
    loadCurrentType() {
      let _ = this;
      _.changedDesigner = {};
      _.haveDesignerModify = false;
      _.chiamataAxios(
        "GET",
        "/auth/portal/getConfigurations/" + _.configType[_.currentTypeId].code
      ).then((response) => {
        _.currentType = response.data;
        _.currentType.subType = _.normalizeArrayKeyValSubTypes(_.currentType.subType);
      });
    },
    onFileChange(subType) {
      let _ = this;
      let file = _.files[subType];
      if (!file) return;
      if (file.size > 1048576) {
        let html = "<strong>Max size 1Mb</strong>";
        Swal.fire({
          type: "error",
          html: html,
        });
        return;
      }
      let reader = new FileReader();
      reader.onload = (e) => {
        let base64 = e.target.result;
        _.currentType.subType = _.currentType.subType.map((configurazione) => {
          if (configurazione.code === subType) {
            configurazione.value = base64;
            configurazione.preview = base64;
          }
          return configurazione;
        });

        _.files[subType] = null;
      };
      reader.readAsDataURL(file);
    },
    getArrayValue(json) {
      try {
        let values = []
        for (let element of json) {
          if (typeof element === 'string' || typeof element === 'number') {
            values.push({ code: element, dex: element });
          } else if (typeof element === 'object' && element.code && element.dex) {
            values.push({ code: element.code, dex: element.dex });
          }
        }
        //let json = JSON.parse(str);
        return values
      } catch (e) {
        return [];
      }
    },

    isArray(str) {
      try {
        let json = JSON.parse(str);
        return Array.isArray(json);
      } catch (e) {
        return false;
      }
      return true;
    },
    loadData() {
      let _ = this;
      _.configuration = {};
      _.RBAC_configuration_VIEW_CONFIGURATION = this.checkUserRole(
        "configuration",
        "VIEW_CONFIGURATION"
      );
      _.RBAC_configuration_EDIT_CONFIGURATION = this.checkUserRole(
        "configuration",
        "EDIT_CONFIGURATION"
      );
      _.chiamataAxios("GET", "/auth/portal/listConfigurationsCategories").then(
        (response) => {
          _.configType = response.data;
          _.panel = null;
        }
      );
    },
    normalizeArrayKeyValSubTypes(subTypes) {
      if (!Array.isArray(subTypes)) return subTypes;

      return subTypes.map((subType) => {
        if (!subType || subType.contentType !== "arrayKeyVal") {
          return subType;
        }

        return {
          ...subType,
          value: this.normalizeArrayKeyValValue(subType.value, subType.validValues),
        };
      });
    },
    normalizeArrayKeyValValue(rawValue, validValues) {
      if (!Array.isArray(rawValue)) {
        return [];
      }

      return rawValue.map((entry) => {
        if (entry && typeof entry === "object" && Object.prototype.hasOwnProperty.call(entry, "key")) {
          return {
            key: entry.key,
            values: entry.values || "",
          };
        }

        if (entry && typeof entry === "object" && Object.prototype.hasOwnProperty.call(entry, "value")) {
          return {
            key: entry.value,
            values: entry.customText || "",
          };
        }

        return {
          key: entry,
          values: "",
        };
      });
    },
    saveConfiguration() {
      let _ = this;
      const normalizedSubType = _.normalizeArrayKeyValSubTypes(_.currentType.subType);
      _.currentType.subType = normalizedSubType;
      this.chiamataAxios(
        "POST",
        "/auth/portal/setConfigurations/" + _.currentType.code,
        { body: { subType: normalizedSubType } }
      ).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadCurrentType();
        }
      });
    },
  },
};
</script>
<style>
.editConfigurationApp .editConfigurationTabs {
  width: auto !important;
  float: left !important;
  flex: none !important;
  padding: 12px !important;
}

.editConfigurationApp .editConfigurationTabs .v-tab {
  text-align: left !important;
  justify-content: left !important;
}

.editConfigurationApp .tiptap-vuetify-editor .v-sheet {
  margin-top: 0px !important;
}

.cardTitleDiv {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  width: calc(100% - 40px);
  text-align: center;
  overflow-wrap: break-word;
  word-break: break-word;
}

.cardTitle {
  padding-left: 5px;
  padding-top: 0px;
}

.cardTitleFlag {
  margin-top: 3px;
  margin-right: 3px;
}

.cardTextContainer {
  padding-top: 0px;
}
</style>